"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledValue = exports.StyledSingleRemoveIcon = exports.StyledSearchIcon = exports.StyledRemoveIcon = exports.StyledRemove = exports.StyledOpenIcon = exports.StyledMultiValue = exports.CLASS_NAME_PREFIX = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _tagsSelect = require("../../../../icons-react/tags-select");
var _excluded = ["children", "innerProps", "data"],
  _excluded2 = ["children", "components", "controlChildren", "isMulti", "isClearable", "isSearchable", "placeholder", "closeMenuOnSelect", "blurInputOnSelect"],
  _excluded3 = ["ClearIndicator", "MultiValueRemove", "Option"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CLASS_NAME_PREFIX = exports.CLASS_NAME_PREFIX = 'selector';
var PLACEHOLDER_DEFAULT = 'Выберите...';
var NO_OPTIONS_DEFAULT = 'Ничего не найдено';
var StyledSearchIcon = exports.StyledSearchIcon = (0, _styledComponents["default"])(_tagsSelect.Search).withConfig({
  displayName: "Selector__StyledSearchIcon",
  componentId: "sc-1051oob-0"
})(["cursor:pointer;flex-shrink:0;height:16px;width:16px;opacity:0;"]);
var StyledSingleRemoveIcon = exports.StyledSingleRemoveIcon = (0, _styledComponents["default"])(_tagsSelect.Remove).withConfig({
  displayName: "Selector__StyledSingleRemoveIcon",
  componentId: "sc-1051oob-1"
})(["cursor:pointer;flex-shrink:0;opacity:0;min-height:12px;min-width:12px;stroke:#046ad9;"]);
var StyledSelector = (0, _styledComponents["default"])(_reactSelect["default"]).withConfig({
  displayName: "Selector__StyledSelector",
  componentId: "sc-1051oob-2"
})([".", "__menu{box-shadow:0 2px 10px 0 rgba(0,0,0,0.1);}.", "__control{background:none;border:none;box-shadow:none;display:flex;}.", "__value-container{display:flex;box-sizing:content-box;flex:1;padding:0;position:relative;}.", "__multi-value{background-color:transparent;border:1px solid #c2c5cc;border-radius:13px;height:26px;user-select:none;}.", "__multi-value__label{color:#17181a;font-size:14px;height:24px;line-height:24px;padding:0 0 0 10px;}.", "__placeholder{color:#919499;cursor:pointer;font-size:14px;margin:0;position:initial;transform:initial;white-space:nowrap;position:absolute;width:100%;left:2px;", "}.", "__menu-list{::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-thumb{background-color:#c2c5cc;border-radius:40px;}}:hover{", ",", "{opacity:1;}}", ""], CLASS_NAME_PREFIX, CLASS_NAME_PREFIX, CLASS_NAME_PREFIX, CLASS_NAME_PREFIX, CLASS_NAME_PREFIX, CLASS_NAME_PREFIX, function (_ref) {
  var isRequired = _ref.isRequired;
  return isRequired && (0, _styledComponents.css)(["&::after{content:' *';color:red;font-size:18px;font-weight:bold;}"]);
}, CLASS_NAME_PREFIX, StyledSingleRemoveIcon, StyledSearchIcon, function (props) {
  return props.isDisabled && "\n    cursor: default;\n    user-select: none;\n    opacity: 0.5;\n  ";
});
var StyledValue = exports.StyledValue = _styledComponents["default"].div.withConfig({
  displayName: "Selector__StyledValue",
  componentId: "sc-1051oob-3"
})(["align-items:center;display:flex;.", "__single-value{background-color:transparent;color:#17181a;font-size:14px;height:26px;line-height:26px;margin:2px 0;max-width:initial;position:initial;transform:initial;user-select:none;}"], CLASS_NAME_PREFIX);
var StyledMultiValue = exports.StyledMultiValue = _styledComponents["default"].div.withConfig({
  displayName: "Selector__StyledMultiValue",
  componentId: "sc-1051oob-4"
})(["align-items:center;display:flex;margin-right:10px;overflow:hidden;"]);
var StyledOpenIcon = exports.StyledOpenIcon = (0, _styledComponents["default"])(_tagsSelect.Open).withConfig({
  displayName: "Selector__StyledOpenIcon",
  componentId: "sc-1051oob-5"
})(["cursor:pointer;flex-shrink:0;height:6px;margin-left:5px;width:10px;"]);
var StyledRemove = exports.StyledRemove = _styledComponents["default"].div.withConfig({
  displayName: "Selector__StyledRemove",
  componentId: "sc-1051oob-6"
})(["cursor:pointer;padding:0 8px !important;background:none !important;> svg{height:10px;width:10px;}:hover{background-color:transparent !important;}"]);
var StyledRemoveIcon = exports.StyledRemoveIcon = (0, _styledComponents["default"])(_tagsSelect.Remove).withConfig({
  displayName: "Selector__StyledRemoveIcon",
  componentId: "sc-1051oob-7"
})([""]);
var StyledOption = _styledComponents["default"].div.withConfig({
  displayName: "Selector__StyledOption",
  componentId: "sc-1051oob-8"
})(["", " cursor:pointer;line-height:24px;min-height:44px;padding:10px;& + &{border-top:1px solid #d8d8d8;line-height:23px;}&:hover{background-color:#dcedff;}"], function (_ref2) {
  var isHighlighted = _ref2.isHighlighted;
  return isHighlighted && (0, _styledComponents.css)(["font-size:15px;font-weight:600;"]);
});
var getMultiValueRemove = function getMultiValueRemove(_ref3) {
  var innerProps = _ref3.innerProps;
  return /*#__PURE__*/_react["default"].createElement(StyledRemove, innerProps, /*#__PURE__*/_react["default"].createElement(StyledRemoveIcon, null));
};
var getSingleValueRemove = function getSingleValueRemove(_ref4) {
  var innerProps = _ref4.innerProps;
  return /*#__PURE__*/_react["default"].createElement(StyledRemove, innerProps, /*#__PURE__*/_react["default"].createElement(StyledSingleRemoveIcon, null));
};
var getDropdownIndicator = function getDropdownIndicator(_ref5) {
  var innerProps = _ref5.innerProps;
  return /*#__PURE__*/_react["default"].createElement(StyledSearchIcon, innerProps);
};
var getOption = function getOption(customOption) {
  return function (_ref6) {
    var children = _ref6.children,
      innerProps = _ref6.innerProps,
      data = _ref6.data,
      props = (0, _objectWithoutProperties2["default"])(_ref6, _excluded);
    return /*#__PURE__*/_react["default"].createElement(StyledOption, (0, _extends2["default"])({
      isHighlighted: data.isHighlighted
    }, innerProps), customOption ? customOption(_objectSpread({
      data: data
    }, props)) : children);
  };
};
var Selector = /*#__PURE__*/function (_React$PureComponent) {
  function Selector(props) {
    var _props$value;
    var _this;
    (0, _classCallCheck2["default"])(this, Selector);
    _this = _callSuper(this, Selector, [props]);
    _this.controlRef = void 0;
    _this.toggleFocus = function (_ref7) {
      var target = _ref7.target;
      _this.setState({
        isFocused: target === document.activeElement
      });
    };
    _this.controlRef = /*#__PURE__*/_react["default"].createRef();
    var initialValue = ((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.label) || '';
    _this.state = {
      keyUpValue: initialValue,
      isFocused: false
    };
    _this.setKeyUpValue = _this.setKeyUpValue.bind(_this);
    _this.toggleFocus = _this.toggleFocus.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Selector, _React$PureComponent);
  return (0, _createClass2["default"])(Selector, [{
    key: "setKeyUpValue",
    value: function setKeyUpValue(ev) {
      var _ev$target;
      this.setState({
        keyUpValue: ev === null || ev === void 0 || (_ev$target = ev.target) === null || _ev$target === void 0 ? void 0 : _ev$target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        _this$props$component = _this$props.components,
        components = _this$props$component === void 0 ? {} : _this$props$component,
        controlChildren = _this$props.controlChildren,
        isMulti = _this$props.isMulti,
        isClearable = _this$props.isClearable,
        isSearchable = _this$props.isSearchable,
        _this$props$placehold = _this$props.placeholder,
        placeholder = _this$props$placehold === void 0 ? PLACEHOLDER_DEFAULT : _this$props$placehold,
        closeMenuOnSelect = _this$props.closeMenuOnSelect,
        _this$props$blurInput = _this$props.blurInputOnSelect,
        blurInputOnSelect = _this$props$blurInput === void 0 ? true : _this$props$blurInput,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded2);
      var _this$state = this.state,
        keyUpValue = _this$state.keyUpValue,
        isFocused = _this$state.isFocused;
      var ClearIndicator = components.ClearIndicator,
        MultiValueRemove = components.MultiValueRemove,
        Option = components.Option,
        otherComponents = (0, _objectWithoutProperties2["default"])(components, _excluded3);
      var filteredComponents = _objectSpread({
        MultiValueRemove: MultiValueRemove || getMultiValueRemove,
        ClearIndicator: ClearIndicator || getSingleValueRemove,
        Option: Option || getOption(children),
        DropdownIndicator: getDropdownIndicator,
        IndicatorSeparator: null
      }, otherComponents);
      var shouldListenKeyUp = !isMulti && !isClearable;
      return /*#__PURE__*/_react["default"].createElement("div", shouldListenKeyUp && {
        onKeyUp: this.setKeyUpValue
      }, /*#__PURE__*/_react["default"].createElement(StyledSelector, (0, _extends2["default"])({}, props, {
        classNamePrefix: CLASS_NAME_PREFIX,
        components: filteredComponents,
        isClearable: isClearable,
        isMulti: isMulti,
        isSearchable: isSearchable,
        placeholder: placeholder,
        closeMenuOnSelect: closeMenuOnSelect,
        escapeClearsValue: true,
        backspaceRemovesValue: true,
        blurInputOnSelect: blurInputOnSelect
      }, shouldListenKeyUp && _objectSpread({
        onFocus: this.toggleFocus,
        onBlur: this.toggleFocus
      }, isFocused && keyUpValue === '' && {
        value: null
      }), {
        noOptionsMessage: function noOptionsMessage() {
          return NO_OPTIONS_DEFAULT;
        }
      })));
    }
  }]);
}(_react["default"].PureComponent);
Selector.CLASS_NAME_PREFIX = void 0;
Selector.labelPropType = void 0;
Selector.StyledOpenIcon = void 0;
Selector.StyledValue = void 0;
Selector.optionPropTypes = void 0;
Selector.valuePropType = void 0;
Selector.StyledRemove = void 0;
Selector.StyledMultiValue = void 0;
Selector.StyledSingleRemoveIcon = void 0;
Selector.StyledSearchIcon = void 0;
Selector.StyledRemoveIcon = void 0;
Selector.StyledOption = void 0;
Selector.CLASS_NAME_PREFIX = CLASS_NAME_PREFIX;
Selector.StyledOpenIcon = StyledOpenIcon;
Selector.StyledValue = StyledValue;
Selector.StyledOption = StyledOption;
Selector.StyledRemoveIcon = StyledRemoveIcon;
Selector.StyledSearchIcon = StyledSearchIcon;
Selector.StyledSingleRemoveIcon = StyledSingleRemoveIcon;
Selector.StyledMultiValue = StyledMultiValue;
Selector.StyledRemove = StyledRemove;
var _default = exports["default"] = Selector;